"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@folio/stripes/components");
var _hooks = require("../hooks");
var _EditableRefdataCategoryList = _interopRequireDefault(require("../EditableRefdataCategoryList"));
var _EditableRefdataList = _interopRequireDefault(require("../EditableRefdataList"));
var _FormattedKintMessage = _interopRequireDefault(require("../FormattedKintMessage"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const propTypes = {
  afterQueryCalls: _propTypes.default.object,
  catchQueryCalls: _propTypes.default.object,
  displayConditions: _propTypes.default.shape({
    create: _propTypes.default.bool,
    delete: _propTypes.default.bool,
    view: _propTypes.default.bool
  }),
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  labelOverrides: _propTypes.default.object,
  onClose: _propTypes.default.func,
  refdataEndpoint: _propTypes.default.string
};
const RefdataCategoriesSettings = _ref => {
  let {
    /*
     * Set of extra booleans for controlling access to actions
     * create/delete (View should be handled externally)
     * This will not overwrite "internal" behaviour, ie setting
     * delete to 'true' here would still not render a delete button
     * for a refdata category that has refdata values.
     */
    displayConditions = {
      create: true,
      delete: true,
      edit: true
    },
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    labelOverrides = {},
    // An object containing translation alternatives
    onClose,
    refdataEndpoint
  } = _ref;
  /* A component that allows for editing of refdata categories */
  const [refdataCategory, setRefdataCategory] = (0, _react.useState)();
  const [refState, rdclRef, passedRef] = (0, _hooks.useActionListRef)();
  const kintIntl = (0, _hooks.useKintIntl)(passedIntlKey, passedIntlNS);
  const handleRefdataCategoryClick = rc => {
    setRefdataCategory(rc);
  };
  const pickListValuesLabel = kintIntl.formatKintMessage({
    id: 'settings.pickListValues',
    overrideValue: labelOverrides?.pickListValues
  });
  const renderViewPaneHeader = renderProps => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.PaneHeader, {
    ...renderProps,
    dismissible: true,
    onClose: () => setRefdataCategory(),
    paneTitle: kintIntl.formatKintMessage({
      id: 'refdataCategories.config.viewPaneTitle',
      overrideValue: labelOverrides?.viewPaneTitle,
      fallbackMessage: refdataCategory?.desc
    }, {
      name: refdataCategory?.desc
    })
  });
  const renderLookupPaneHeader = renderProps => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.PaneHeader, {
    ...renderProps,
    dismissible: true,
    lastMenu: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.PaneMenu, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
        disabled: !!refState?.editing,
        marginBottom0: true,
        onClick: () => rdclRef?.current?.create(),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedKintMessage.default, {
          id: "new"
        })
      })
    }),
    onClose: onClose,
    paneTitle: kintIntl.formatKintMessage({
      id: 'settings.pickLists',
      overrideValue: labelOverrides?.pickLists
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Pane, {
      defaultWidth: "fill",
      id: "edit-refdata-desc",
      renderHeader: renderLookupPaneHeader,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditableRefdataCategoryList.default, {
        ref: passedRef,
        afterQueryCalls: {
          post: json => {
            setRefdataCategory(json);
          }
        },
        displayConditions: displayConditions,
        handleRefdataCategoryClick: handleRefdataCategoryClick,
        hideCreateButton: true,
        onConfirmDelete: id => {
          if (refdataCategory?.id === id) {
            setRefdataCategory();
          }
        },
        refdataEndpoint: refdataEndpoint
      })
    }), refdataCategory?.desc && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Pane, {
      defaultWidth: "fill",
      id: "settings-refdataCategories-viewPane",
      renderHeader: renderViewPaneHeader,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_components.Row, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
          xs: 8,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
            label: kintIntl.formatKintMessage({
              id: 'refdataCategory.refdataCategory',
              overrideValue: labelOverrides?.refdataCategory
            }),
            value: refdataCategory.desc
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Col, {
          xs: 4,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.KeyValue, {
            label: kintIntl.formatKintMessage({
              id: 'refdataCategory.noOfValues',
              overrideValue: labelOverrides?.noOfValues
            }),
            value: refdataCategory?.values?.length
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_EditableRefdataList.default, {
        afterQueryCalls: {
          put: json => setRefdataCategory(json),
          delete: json => setRefdataCategory(json)
        },
        desc: refdataCategory?.desc,
        displayConditions: displayConditions,
        label: pickListValuesLabel,
        refdataEndpoint: refdataEndpoint
      })]
    })]
  });
};
RefdataCategoriesSettings.propTypes = propTypes;
var _default = exports.default = RefdataCategoriesSettings;